export default "__VITE_ASSET__nMXUjxR3__$_?react__"